import React, { useState, useEffect } from "react";
import Header from '../Components/PageComponent/Layout/Header';
import Footer from '../Components/PageComponent/Layout/Footer';
import Modal from "react-bootstrap/Modal";
import { Link, useParams } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { Image } from "react-bootstrap";
import { fetchSupplierProductDetail } from "../redux/actions/ProjectReportAction";
const ProductDetails = () => {
    let { id } = useParams();
    const [description, setDescription] = useState("");
    const [modalShow, setModalShow] = useState(false);
    const handleClose = () => setModalShow(false);
    const dispatch = useDispatch();
    const {
        AuthReducer: { auth, errors },
    } = useSelector((state) => state);
    const { supplierProductDetail } = useSelector((state) => state.projectReportReducer);
    useEffect(() => {
        dispatch(fetchSupplierProductDetail(id));
    }, [id]);

    return (
        <>
            <Header />
            <div className="bg-gray border-bottom py-3">
                <Modal show={modalShow} onHide={handleClose} centered animation={false}>
                    <Modal.Header closeButton>Description</Modal.Header>
                    <Modal.Body>
                        <div className="">{supplierProductDetail?.description}</div>
                    </Modal.Body>
                </Modal>
            </div>
            <div className="bg-gray mt-5">
                <div className="container">
                    <div className="hero-block-two hero-block-two-industry">
                        <div className="hero-block-two-img">
                            <Image
                                src={`https://msmesupplier.s3.ap-south-1.amazonaws.com/${supplierProductDetail?.image}`}
                                objectFit="cover"
                                layout="fill"
                            />
                        </div>
                        <div className="hero-block-two-body">
                            <div className="hero-block-two-body-top flex-column">
                                <div className="hero-block-two-body-left">
                                    <p className="mb-3 c-badge bg-white text-primary">

                                    </p>
                                    <h4 className="text-capitalize mb-3">{supplierProductDetail?.name}</h4>

                                    <div className="">

                                        <span className="d-block">
                                            <strong>Supplier Name : </strong> {supplierProductDetail?.supplier?.name}
                                        </span>

                                        <span className="d-block">
                                            <strong>Manufactured By : </strong> {supplierProductDetail?.manufactured_by}
                                        </span>



                                    </div>


                                    <p
                                        className="mb-0 mt-4 fw-medium text-secondary dot-3 col-md-10"
                                        dangerouslySetInnerHTML={{
                                            __html: supplierProductDetail?.description && supplierProductDetail?.description,
                                        }}
                                    ></p>
                                    
                                </div>
                                <div className={'d-flex justify-content-between align-items-end'}>
                                    <div className="col-6">
                                    <p
                                        onClick={() => {
                                            setModalShow(true);
                                            setDescription(supplierProductDetail?.description);
                                        }}
                                        className="mt-2 mb-0 cursor f-small text-secondary opacity-75 fw-bold"
                                    >
                                        View all details
                                    </p>
                                        <h3 className="mb-0">₹ {supplierProductDetail?.price} /-</h3>
                                    </div>
                                    <div className="col-6 text-center">
                                        <button

                                            className="btn-primary btn-theme btn"
                                        >
                                            Get Quotation
                                        </button>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </>
    )
}

export default ProductDetails;